import React, { useEffect, useRef } from 'react';
import { Sparkles } from 'lucide-react';
import Reveal from './Reveal';
import './Hero.css';

export default function Hero({
  token,
  onCtaClick,
  eyebrow = 'Faye Travel+ — exclusive to policyholders',
  headline = 'Your trip just got an upgrade',
  subhead = 'Airport lounge access, eSIM data, and exclusive travel perks — bundled together for less than they cost apart.',
  ctaLabel = 'Show me the bundles',
}) {
  const resolvedHeadline = token?.valid && token.firstName && token.destination
    ? `${token.firstName}, your ${token.destination} trip just got an upgrade`
    : headline;

  const artRef = useRef(null);
  const imgRef = useRef(null);

  useEffect(() => {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return undefined;
    const art = artRef.current;
    const img = imgRef.current;
    if (!art || !img) return undefined;

    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        const rect = art.getBoundingClientRect();
        const progress = Math.min(Math.max(-rect.top / (rect.height || 1), 0), 1);
        img.style.transform = `scale(${1 + progress * 0.06}) translateY(${progress * 16}px)`;
        ticking = false;
      });
    };

    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <section className="tp-hero">
      <div className="container tp-hero__grid">
        <Reveal as="div" className="tp-hero__content">
          <span className="tp-hero__eyebrow label-m">
            <Sparkles size={14} strokeWidth={1.5} />
            {eyebrow}
          </span>
          <h1 className="display-3 tp-hero__headline">{resolvedHeadline}</h1>
          <p className="body-l tp-hero__subhead">
            {subhead}
          </p>
          <button type="button" className="btn btn-primary tp-hero__cta" onClick={onCtaClick}>
            {ctaLabel}
          </button>
        </Reveal>
        <Reveal as="div" delay={120} className="tile tp-hero__art" ref={artRef}>
          <img
            ref={imgRef}
            src="/assets/images/hero-cliffs.jpg"
            alt="A turquoise cove seen from a coastal cliff trail"
            className="tp-hero__art-img"
          />
        </Reveal>
      </div>
    </section>
  );
}
